export class BucketFileProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "BucketFileProbeRequestCloudEnum",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "credentialsSecretArn",
            "baseName": "credentialsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleSize",
            "baseName": "sampleSize",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketFileProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var BucketFileProbeRequestCloudEnum;
(function (BucketFileProbeRequestCloudEnum) {
    BucketFileProbeRequestCloudEnum["BUCKET_FILE_PROBE_CLOUD_AWS"] = "AWS";
    BucketFileProbeRequestCloudEnum["BUCKET_FILE_PROBE_CLOUD_GCP"] = "GCP";
})(BucketFileProbeRequestCloudEnum || (BucketFileProbeRequestCloudEnum = {}));
